"use client";

import ScrollAnimation from "./ScrollAnimation";
import { motion } from "framer-motion";

export default function AboutSection() {
  return (
    <section className="section-block text-center py-16" id="about">
      <ScrollAnimation animation="fade-in">
        <h2 className="mb-12">Das sind wir</h2>
        
        <div className="max-w-4xl mx-auto px-4">
          <motion.div 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="band-description bg-gradient-to-br from-primary/40 to-black/60 backdrop-blur-md border border-white/10 p-8 md:p-12 rounded-2xl shadow-2xl relative overflow-hidden group"
          >
            {/* Subtle decorative element */}
            <div className="absolute -top-24 -right-24 w-48 h-48 bg-accent/5 rounded-full blur-3xl group-hover:bg-accent/10 transition-colors duration-700" />
            
            <div className="relative z-10 space-y-6 text-lg md:text-xl leading-relaxed font-serif text-gray-200">
              <p>
                Wir, <span className="text-accent font-bold font-oswald uppercase tracking-wider">Becoming Wind</span>, 
                sind eine Melodic-Metal-Band, die kraftvolle Gitarrenriffs mit orchestralen Arrangements und erzählerischen Texten verbindet. 
                Unser Sound ist vielseitig, einzigartig und seit Juni 2025 auf unserem Debütalbum 
                <span className="text-accent italic font-medium"> &quot;Chapter I: Ex Libris&quot;</span> zu hören. 
                Dieses Album markiert den ersten großen Meilenstein auf unserer musikalischen Reise.
              </p>
              
              <p className="pt-4 border-t border-white/5">
                Vor uns liegen spannende Monate mit neuer Musik, Musikvideos und zahlreichen Live-Auftritten. 
                Alle aktuellen Infos gibt es immer hier auf der Website oder auf unseren verlinkten Social-Media-Kanälen. 
                Wir sind stets offen für Nachrichten, Feedback oder Kooperationen und freuen uns auf neue Begegnungen!
              </p>
            </div>

            {/* Bottom accent line */}
            <div className="absolute bottom-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-accent/30 to-transparent" />
          </motion.div>
        </div>
      </ScrollAnimation>
    </section>
  );
}
